// src/pages/Home.jsx
import React from 'react';
import Chat from '../components/Chat';
import DateBanner from '../components/DateBanner';
import Window from '../components/Window';

const Home = () => {
  return (
    <div className="flex flex-col items-center w-full h-full">
      <div className='h-[28%] w-auto relative bottom-[-8%]'>
        <img src="/assets/logo.png" alt="로고 이미지" className="w-full h-full object-cover" />
      </div>
      <div className='w-full h-[30%] overflow-hidden'>
        <img src="/assets/main.png" alt="메인 이미지" className="w-full h-full object-cover" style={{ objectPosition: '30% 23%' }} />
      </div>
      <div className='w-full h-[37%] flex gap-8 pt-10'>
        <div className='w-[35%] h-full'><Window text="Chatting" content={<Chat />} className="w-full h-full shadow-sm "/></div>
        <div className='w-[35%] h-full'><Window text="D-Day" content={<DateBanner startDate="2023-12-24" imgSrc="/assets/date-origin.png" />}className="w-full h-full shadow-sm "/></div>
        <div className='w-[35%]'>
          <div className='w-full h-[65%]'><Window text="List" className="w-full h-full shadow-sm " /></div>
          <div className='w-full h-[30%] overflow-hidden mt-[5%] border border-gray-300 shadow-sm rounded-lg'>
            <img src="/assets/deco-1.png" alt="데코 이미지" className="w-full h-full object-cover scale-[1.3]" style={{ objectPosition: '30% 55%' }} />
          </div>
        </div>
      </div>
      <div className='w-full flex justify-center'>
        <img src="/assets/logo2.png" alt="로고 이미지" className="h-[15vh] object-cover" />
      </div>
    </div>
  );
};

export default Home;
